import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { MyContext } from "../../hooks/useContextProvider";
import { useNavigate } from "react-router-dom";
import useBreakPoints from "../../hooks/useBreakPoints";
import { toast } from "react-toastify";
import { Minus, Plus, X } from "lucide-react";
import Loader from "../../Component/Loader";

const Cart = () => {
  const { cartList, callCartDetails, guestCartData, updateGuestCartData } =
    useContext(MyContext);
  const guestMode = localStorage.getItem("guestMode");
  console.log("cartList: ", cartList);
  const navigate = useNavigate();
  const { isMobile } = useBreakPoints();
  const [subTotal, setSubTotal] = useState();
  const [cartDetails, setCartDetail] = useState([]);
  console.log("cartDetails: ", cartDetails);

  const [loading, setloading] = useState(false);
  const [totalAmount, setTotalAmount] = useState("");
  console.log("totalAmount: ", totalAmount);

  useEffect(() => {
    callCartDetails();
  }, []);

  useEffect(() => {
    if (guestMode === "true") {
      setCartDetail(guestCartData);
    } else {
      setCartDetail(cartList);
    }
  }, [guestMode, guestCartData, cartList]);

  useEffect(() => {
    const total = cartDetails
      ?.reduce((acc, item) => {
        const price = parseFloat(item.variantDetails?.price);
        console.log("price: ", price);
        const qty = parseInt(item.qty);
        console.log("qty: ", qty);
        const discountedPrice =
          item.productDetails?.isDiscountApplicable === "true"
            ? price -
            (price * parseFloat(item.productDetails?.discountedPercentage)) /
            100
            : price;
        return acc + qty * discountedPrice;
      }, 0)
      .toFixed(2);

    setTotalAmount(total);
  }, [cartDetails]);

  async function deleteCartItem(id) {
    let formData = new FormData();
    const token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");
    formData.append("id", id);
    formData.append("clientId", process.env.REACT_APP_Client_Id);
    formData.append("isDelete", "Yes");
    formData.append("created_by", "customer");
    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}deletecart?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          callCartDetails();
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
        setloading(false);
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  }

  async function changeQty(value, index) {
    let formData = new FormData();
    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");
    formData.append("id", index);
    formData.append("clientId", process.env.REACT_APP_Client_Id);
    formData.append("qty", value);
    formData.append("created_by", "Customer");
    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}editcart?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          callCartDetails();
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
        setloading(false);
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  }

  const handleRemoveGuestCart = (index) => {
    let arr = [...guestCartData];
    arr?.splice(index, 1);
    updateGuestCartData(arr);
  };
  const handleAddQtyGuestCart = (index) => {
    let arr = [...guestCartData];
    arr[index]["qty"] = +arr[index]["qty"] + 1;
    updateGuestCartData(arr);
  };
  const handleDeleteQtyGuestCart = (index) => {
    let arr = [...guestCartData];
    arr[index]["qty"] = +arr[index]["qty"] - 1;
    updateGuestCartData(arr);
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Breadcrumb mainTitle={"Cart"} title={"Cart"} subTitle={"Home"} />

      <section className="container layout-pb-lg" style={{ marginBottom: 40 }}>
        {cartList?.length > 0 ? (
          <>
            <div className="table-responsive">
              <table
                className="custom-table-cart"
                style={{
                  minWidth: 970,
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "normal",
                      }}
                    >
                      PRODUCT
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "normal",
                      }}
                    >
                      PRICE
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "normal",
                      }}
                    >
                      QUANTITY
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "normal",
                      }}
                    >
                      SUBTOTAL
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {cartDetails?.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td
                          style={{
                            padding: "20px 10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "5px",
                                marginTop: 0,
                                marginRight: "20px",
                              }}
                            >
                              <X
                                size={24}
                                color="black"
                                onClick={() => {
                                  if (guestMode === "true") {
                                    handleRemoveGuestCart(i);
                                  } else {
                                    deleteCartItem(item?.id);
                                  }
                                }}
                              />
                            </button>
                            <img
                              src={
                                JSON.parse(
                                  item?.variantDetails?.variantImageGallery?.replace(
                                    /'/g,
                                    '"'
                                  ) || "[]"
                                )?.[0]
                              }
                              alt="Ring"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                borderRadius: 12,
                              }}
                            />
                            <div
                              style={{
                                marginLeft: "20px",
                              }}
                            >
                              <div
                                className="unna-regular"
                                style={{ fontSize: 22, lineHeight: "26px" }}
                              >
                                {item?.productDetails?.productName}
                              </div>
                              <div className="jost-font mt-3">
                                {
                                  item?.productDetails?.maincategory
                                    ?.mainCategoryName
                                }
                                {item?.productDetails?.category?.categoryName &&
                                  `- ${item?.productDetails?.category?.categoryName}`}
                              </div>
                              <div className="jost-font">
                                {item?.variantDetails?.id && (
                                  <>
                                    {
                                      item?.variantDetails?.variantkey?.split(
                                        "-"
                                      )[0]
                                    }{" "}
                                    {item?.variantDetails?.variantkey?.split(
                                      "-"
                                    )?.[1] &&
                                      `- ${item?.variantDetails?.variantkey?.split(
                                        "-"
                                      )?.[1]
                                      }`}
                                    {item?.variantDetails?.variantkey?.split(
                                      "-"
                                    )?.[2] &&
                                      `- ${item?.variantDetails?.variantkey?.split(
                                        "-"
                                      )?.[2]
                                      }`}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "20px 10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          Rs.{" "}
                          {item?.productDetails?.discountedPercentage
                            ? parseFloat(
                              parseFloat(item?.variantDetails?.price) -
                              (item?.variantDetails?.price *
                                item?.productDetails
                                  ?.discountedPercentage) /
                              100
                            ).toFixed(2)
                            : +parseInt(item?.variantDetails?.price)}
                        </td>
                        <td
                          style={{
                            padding: "20px 10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "5px",
                                marginTop: 0,
                              }}
                            >
                              <Minus
                                size={16}
                                color="black"
                                onClick={() => {
                                  if (item.qty > 1) {
                                    if (guestMode === "true") {
                                      handleDeleteQtyGuestCart(i);
                                    } else {
                                      // eslint-disable-next-line
                                      let currentQty = item.qty;
                                      let updatedQty = parseInt(currentQty) - 1;
                                      changeQty(updatedQty, item.id);
                                    }
                                  }
                                }}
                              />
                            </button>
                            <input
                              type="text"
                              value={item?.qty}
                              style={{
                                width: "40px",
                                textAlign: "center",
                                margin: "0 10px",
                                border: "1px solid #ddd",
                                padding: "5px",
                                background: "white",
                              }}
                              disabled
                            />
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "5px",
                                marginTop: 0,
                              }}
                            >
                              <Plus
                                size={16}
                                color="black"
                                onClick={() => {
                                  if (guestMode === "true") {
                                    handleAddQtyGuestCart(i);
                                  } else {
                                    // eslint-disable-next-line
                                    let currentQty = item.qty;
                                    let updatedQty = parseInt(currentQty) + 1;
                                    changeQty(updatedQty, item.id);
                                  }
                                }}
                              />
                            </button>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "20px 10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          Rs.{" "}
                          {parseFloat(
                            (item?.productDetails?.discountedPercentage
                              ? parseFloat(
                                parseFloat(item?.variantDetails?.price) -
                                (item?.variantDetails?.price *
                                  item?.productDetails
                                    ?.discountedPercentage) /
                                100
                              ).toFixed(2)
                              : +parseInt(item?.variantDetails?.price)) *
                            +item?.qty
                          ).toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                // marginBottom: "20px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginRight: "20px",
                }}
              >
                Total:
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Rs. {totalAmount}
              </div>
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                textAlign: "right",
                marginBottom: "5px",
              }}
            >
              Shipping, taxes, & discounts calculated during checkout.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <button
                style={{
                  padding: "15px",
                  backgroundColor: "#00205b",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  marginBottom: "10px",
                  width: 320,
                }}
                onClick={() => {
                  navigate("/checkout", { state: cartDetails });
                }}
              >
                CHECKOUT
              </button>
            </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "Nunito Sans, sans-serif",
              color: "#333",
              height: 345,
              padding: "20px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
                position: "relative",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ccc"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide custom-cart-svg lucide-shopping-cart"
              >
                <circle cx="8" cy="21" r="1"></circle>
                <circle cx="19" cy="21" r="1"></circle>
                <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
              </svg>
            </div>
            <h2
              className="unna-regular"
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Your Cart is empty
            </h2>
            <p
              style={{
                fontSize: "16px",
                color: "#666",
                marginBottom: "20px",
              }}
            >
              You have no items in your Cart.
            </p>
            <button
              className="jost-font"
              onClick={() => {
                navigate("/shop");
              }}
              style={{
                backgroundColor: "#00264d",
                color: "white",
                border: "none",
                padding: "15px 20px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              CONTINUE SHOPPING
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default Cart;
